"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FeaturedImage;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classnames = _interopRequireDefault(require("classnames"));

function FeaturedImage(_ref) {
  var src = _ref.src,
      srcSet = _ref.srcSet,
      sizes = _ref.sizes,
      alt = _ref.alt,
      width = _ref.width,
      height = _ref.height;
  if (!src) return (0, _preact.h)("hr", {
    className: (0, _classnames.default)('seperator', 'm-h', 'm-b-0')
  });
  var role = alt && alt.trim() !== '' ? 'img' : 'presentation';
  return (0, _preact.h)("div", {
    className: "box__pad--sides--large-only"
  }, (0, _preact.h)("img", {
    className: "thread-details-featured-image qa-thread-featured-image",
    "data-qa": "thread-featured-image",
    role: role,
    src: (0, _absoluteUrlRuntime.resolveUrl)(src),
    srcSet: srcSet,
    sizes: sizes !== null && sizes !== void 0 ? sizes : '100vw',
    alt: alt,
    width: width,
    height: height
  }));
}